var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showFindInLayers
    ? _c("div", { staticClass: "find-in-layers-container" }, [
        _c("div", { staticClass: "find-in-layers-panel" }, [
          _c(
            "div",
            { staticClass: "search-input-wrapper" },
            [
              _c(_setup.CInput, {
                ref: "inputComponentRef",
                attrs: {
                  "input-class": "search-input",
                  type: "text",
                  autocomplete: "off",
                  placeholder: "Find in Layers (name or layer ID)",
                  debounce: 500,
                },
                on: { debounce: _setup.onUpdateSearchDecounced },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "result-counter" }, [
                            _vm._v(
                              _vm._s(_setup.currentResultNumber) +
                                " of " +
                                _vm._s(_setup.totalCount)
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3180241749
                ),
                model: {
                  value: _setup.searchQueryModel,
                  callback: function ($$v) {
                    _setup.searchQueryModel = $$v
                  },
                  expression: "searchQueryModel",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _c(_setup.CButton, {
                staticClass: "btn-icon",
                attrs: {
                  size: "icon",
                  variant: "link",
                  icon: ["fas", "chevron-up"],
                  disabled: !_setup.hasResults,
                  title: "Focus Previous",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _setup.focusPrevious.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.CButton, {
                staticClass: "btn-icon",
                attrs: {
                  size: "icon",
                  variant: "link",
                  icon: ["fas", "chevron-down"],
                  disabled: !_setup.hasResults,
                  title: "Focus Next",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _setup.focusNext.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "divider" }),
              _vm._v(" "),
              _c(_setup.CButton, {
                staticClass: "btn-icon close-btn",
                attrs: {
                  size: "icon",
                  variant: "link",
                  icon: ["fas", "times"],
                  title: "Close",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _setup.handleClose.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }